export default function CartNoProducts (props) {
    return (
        <div className="col-12 my-5 text-center">
            <b className={props.orderPayBody.validation.Products.HasError ? "text-danger" : "text-dark"}>No products in the cart.<br />Go back to the menu to add products.</b>
        </div>
    )
}